<div class="plot-card overflow-hidden">
    <canvas #osborneCanvas></canvas>
</div>